export const getCodeRepositoryName = (name: string | undefined): string =>
  name?.split("/").pop() || ""
